<template>
  <EmdFormGroup
    :label="$t('document')"
    :state="getState($v.recipient.document)"
    required
    :feedbacks="feedbacks($v.recipient.document)"
  >
    <EmdInput
      @input="() => $v.recipient.document.$touch()"
      v-model="recipient.document"
      :mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
      name="document"
      :readonly="disabled"
      :disabled="disabled"
      v-if="canEdit"
    />
    <span v-else>
      {{ recipient.document }}
    </span>
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { recipientValidationsGeneral } from '../validations'
export default {
  name: 'DocumentInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    document: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  validations () {
    return { recipient: recipientValidationsGeneral }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "document": "Número do documento"
    },
    "en-US": {
      "document": "Document  number"
    }
  }
</i18n>
